import { css } from "styled-components";

export default css`
    border-color: #fb7575;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(255, 126, 0, 0.1);
    background: #fff;
`;
